import { render, staticRenderFns } from "./BaseIcon.vue?vue&type=template&id=ec711612&scoped=true&"
import script from "./BaseIcon.vue?vue&type=script&lang=ts&"
export * from "./BaseIcon.vue?vue&type=script&lang=ts&"
import style0 from "./BaseIcon.vue?vue&type=style&index=0&id=ec711612&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec711612",
  null
  
)

export default component.exports